import ForgotPasswordForm from "@/features/auth/forgot-password/components/ForgotPasswordForm";

export default function ForgotPassword() {
  return <ForgotPasswordForm />;
}
